import React, { useEffect, useState, useRef } from 'react';
import { AppContextProvider } from './context';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import _ from 'lodash';
import * as Sentry from '@sentry/react';

import { sendOnboardingMail } from '../api';
import Header from './layout/header/header.component';
import SideBar from './layout/side_bar/side_bar.component';
import MainContainer from './containers/main/main.container';
import Footer from './layout/footer/footer.component';
import ErrorPage from './error_page/error_page.component';
import MFSyncStatus from './common/mf_sync_status/mf_sync_status.component';
import './App.css';

const App = () => {
  //global context state
  const [context, setContext] = useState({
    currencyPrefix: '₹',
    user: window.django.user,
    urls: window.django.urls,
    csrf_token: window.django.csrf,
    tx_id: window.django.tx_id,
    token: window.django.token,
    planDetails: { ...window.django.planDetails },
    fence: window.django.fence,
    geoip: window.django.geoip,
    brokers: [
      'aliceblue',
      'angelbroking',
      'dhan',
      'fivepaisa',
      'groww',
      'motilal',
      'trustline',
      'upstox',
    ],
    portfolios: [
      { id: 'family', name: 'Family Portfolio' },
      ...window.django.portfolios,
    ],
    //holds id of pf to be reset
    //as object, to make sure it triggers on subsequent update of same pf
    //set in case of update_holdings, delete_pf, clear_pf
    //switchId in case of delete, clear to toggle pf in each component
    resetPf: { resetId: 0, switchId: 0 },
    showMfSyncSuccessPf: null,
    mfInBeta: true,
  });

  //android, temp change
  const queryParams = new URLSearchParams(window.location.search);
  const isWebview = queryParams.get('user_agent') === 'webview';

  const triggerSignupAnalyticsEvent = () => {
    try {
      dataLayer.push({ event: 'signup-success' });
    } catch (error) {}
  };

  const triggerOnboardingEmail = () => {
    try {
      sendOnboardingMail();
    } catch (error) {}
  };

  useEffect(() => {
    //populate dummy portfolios
    let pfs = [...context.portfolios];
    const noOfPfs = pfs.length - 1;
    for (let index = 0; index < 5 - noOfPfs; index++) {
      pfs.push({
        id: `dummy_${index + noOfPfs + 1}`,
        name: `Portfolio ${index + noOfPfs + 1}`,
        is_dummy: true,
      });
    }
    setContext({ ...context, portfolios: pfs });
    //for gtag
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('signup')) {
      //when users signup with kite, they get redirected to portfolio
      triggerOnboardingEmail();
      triggerSignupAnalyticsEvent();
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.delete('signup');
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}?${queryParams.toString()}`,
      );
    }
  }, []);

  return (
    <Router basename="/in/portfolio">
      <Switch>
        <Route exact path="/">
          <AppContextProvider
            value={{
              ...context,
              portfoliosById: _.keyBy(context.portfolios, 'id'),
            }}
          >
            <Sentry.ErrorBoundary fallback={<ErrorPage />}>
              {!isWebview ? <Header /> : null}
              <SideBar />
              <MainContainer
                setContext={(data) => setContext({ ...context, ...data })}
              />
              <Footer />
              <MFSyncStatus pf={context.showMfSyncSuccessPf} />
            </Sentry.ErrorBoundary>
          </AppContextProvider>
        </Route>
        <Route path="/sample">
          <AppContextProvider
            value={{
              ...context,
              is_sample: true,
              portfoliosById: _.keyBy(context.portfolios, 'id'),
            }}
          >
            <Sentry.ErrorBoundary fallback={<ErrorPage />}>
              <Header />
              <SideBar />
              <MainContainer />
              <Footer />
            </Sentry.ErrorBoundary>
          </AppContextProvider>
        </Route>
      </Switch>
    </Router>
  );
};

export default withRouter(App);
